export default __webpack_public_path__ + "static/media/element_69.6631a9a6.jpg";